$(document).ready(function(){
  
  $(window).on('resize', function (){
    //ptimgSwitchContainerHeight();
  });
  
  
  $('.container.imageSwitch .switchList a, .container .imageSwitch .switchList a').on('click', function(e){
    
    e.preventDefault();
    
    $(this).closest('.imageSwitch').find('.switchList a').removeClass('current');
    $(this).addClass('current');
    
    $imageToShow = $(this).data('imagetoshow');
    
    $(this).closest('.imageSwitch').find('.switchStage a').removeClass('current');
    
    $(this).closest('.imageSwitch').find('.switchStage img').each(function(){
      if($(this).data('image') == $imageToShow) $(this).parent().addClass('current');
    });
  
  });
  
  //ptimgSwitchContainerHeight();

});

function ptimgSwitchContainerHeight() {
  $('.container.imageSwitch .switchStage').each(function(){
    $(this).height($(this).find('img:first-child').height());
  });
}